import React from 'react'
import { Link } from 'react-router-dom'

export const Product: React.FC = () => {
  return (
    <section className="bg-gradient-to-br from-gray-900 to-black text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-extrabold mb-4">
            Complete DIY Timeshare Exit Package
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Everything you need to legally exit your timeshare without expensive attorneys. 
            Professional-grade materials used by successful customers worldwide.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Product Details */}
          <div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-8 border border-white/20">
              <h3 className="text-2xl font-bold text-blue-200 mb-6">
                What's Included in Your Professional $997 Package:
              </h3>
              
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 bg-blue-200 text-blue-800 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <svg className="w-3 h-3 text-blue-800" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="font-semibold text-white mb-1">
                      200+ Page Comprehensive Legal Guide
                    </h4>
                    <p className="text-gray-300 text-sm">
                      Step-by-step instructions, legal strategies, and everything you need to know 
                      about timeshare law and consumer protection.
                    </p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 bg-blue-200 text-blue-800 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <svg className="w-3 h-3 text-blue-800" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="font-semibold text-white mb-1">
                      Professional Legal Templates
                    </h4>
                    <p className="text-gray-300 text-sm">
                      Ready-to-use demand letters, cancellation notices, and legal filings 
                      formatted exactly like attorneys use.
                    </p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 bg-blue-200 text-blue-800 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <svg className="w-3 h-3 text-blue-800" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="font-semibold text-white mb-1">
                      Company-Specific Exit Strategies
                    </h4>
                    <p className="text-gray-300 text-sm">
                      Targeted approaches for Wyndham, Marriott, Hilton, Disney, Westgate, 
                      and 45+ other timeshare companies.
                    </p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 bg-blue-200 text-blue-800 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <svg className="w-3 h-3 text-blue-800" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="font-semibold text-white mb-1">
                      Credit Protection Strategies
                    </h4>
                    <p className="text-gray-300 text-sm">
                      Proven methods to exit your timeshare without damaging your credit score 
                      or financial reputation.
                    </p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 bg-blue-200 text-blue-800 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <svg className="w-3 h-3 text-blue-800" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="font-semibold text-white mb-1">
                      Negotiation Scripts & Phone Call Guide
                    </h4>
                    <p className="text-gray-300 text-sm">
                      Word-for-word scripts for handling calls with timeshare representatives 
                      and collection agencies.
                    </p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 bg-blue-200 text-blue-800 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <svg className="w-3 h-3 text-blue-800" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="font-semibold text-white mb-1">
                      Email Support & Guidance
                    </h4>
                    <p className="text-gray-300 text-sm">
                      Get help when you need it. Our team provides guidance via email 
                      to ensure your success.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Pricing & CTA */}
          <div>
            <div className="bg-gradient-to-br from-slate-100 to-slate-200 text-slate-800 rounded-lg p-8">
              <div className="text-center mb-6">
                <div className="text-sm font-semibold mb-2">SPECIAL INTRODUCTORY PRICE</div>
                <div className="flex items-center justify-center mb-4">
                  <span className="text-lg line-through text-gray-600 mr-4">$2,997</span>
                  <span className="text-5xl font-bold">$997</span>
                </div>
                <div className="text-sm font-medium mb-4">
                  Save $2,000 off Regular Price
                </div>
                <div className="bg-slate-300 rounded-lg p-3 mb-6">
                  <div className="text-sm font-semibold">Compare to Attorney Fees:</div>
                  <div className="text-xs">Attorneys charge $5,000-$15,000 with no guarantee</div>
                  <div className="text-xs">You save up to $14,000+ with our professional guide</div>
                </div>
              </div>
              
              <Link 
                to="/register"
                className="w-full bg-blue-700 text-white font-bold py-4 px-6 rounded-lg text-lg mb-4 hover:bg-blue-800 transition-colors no-underline block text-center"
              >
                GET PROFESSIONAL GUIDE NOW - $997
              </Link>
              
              <div className="bg-slate-400 rounded-lg p-4 mb-4">
                <div className="text-center text-slate-800 text-sm">
                  <div className="font-semibold mb-1">Professional Solution</div>
                  <div className="text-xs">Start your timeshare exit today</div>
                  <div className="text-xs">+ Lifetime access to updates</div>
                </div>
              </div>
              
              <div className="text-center text-slate-700 text-sm space-y-1">
                <div className="flex items-center justify-center">
                  <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  Instant Digital Download
                </div>
                <div className="flex items-center justify-center">
                  <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  60-Day Money-Back Guarantee
                </div>
                <div className="flex items-center justify-center">
                  <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  Secure Payment Processing
                </div>
              </div>
            </div>
            
            {/* Professional Bonus Section */}
            <div className="bg-blue-700 rounded-lg p-6 mt-6">
              <h4 className="font-bold text-white text-center mb-4">
                PROFESSIONAL BONUSES (Limited Time)
              </h4>
              <div className="space-y-3">
                <div className="flex items-center text-white text-sm">
                  <svg className="w-4 h-4 mr-2 text-blue-200" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  Maintenance Fee Stop Kit ($297 value)
                </div>
                <div className="flex items-center text-white text-sm">
                  <svg className="w-4 h-4 mr-2 text-blue-200" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  State Law Reference Guide ($197 value)
                </div>
                <div className="flex items-center text-white text-sm">
                  <svg className="w-4 h-4 mr-2 text-blue-200" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  Collection Agency Defense Kit ($397 value)
                </div>
              </div>
              <div className="text-center mt-4">
                <span className="bg-blue-200 text-blue-800 px-3 py-1 rounded text-sm font-bold">
                  Total Professional Bonus Value: $891
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}